import { Component, EventEmitter, Input, Output, SimpleChanges, HostListener } from '@angular/core';
import { Project } from '../../../models/masterSearch.model';
import { ProjectViewModel } from '../../../models-views/project.view.model';

@Component({
  selector: 'app-cpd-history',
  standalone: false,
  templateUrl: './cpd-history.component.html',
  styleUrl: './cpd-history.component.scss'
})
export class CpdHistoryComponent {
  listOfHistory: any[] = [];
  groupedHistory: any[] = [];
  @Input() projectId: any;
  @Input() activetab: any;

  constructor(private vm: ProjectViewModel) {
    this.vm.historyList.subscribe((e: any) => {
      this.listOfHistory = e.results || [];
      this.groupedHistory = this.groupHistoryByDate(this.listOfHistory);
      console.log('History data received:', this.listOfHistory);
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if (changes['projectId']?.currentValue && changes['activetab']?.currentValue == 2) {
      console.log(changes['projectId']?.currentValue, changes['activetab']?.currentValue);
      this.vm.getProjectHistry(changes['projectId']?.currentValue);
    }
    // Regroup if input changes
    if (changes['listOfHistory']) {
      this.groupedHistory = this.groupHistoryByDate(this.listOfHistory);
    }
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.collapseAllActivities();
  }

  toggleActivityExpand(event: Event, item: any) {
    event.stopPropagation();
    const currentState = item.expandedText;
    // Optional: collapse others if you want only one open at a time
    this.collapseAllActivities(); 
    item.expandedText = !currentState;
  }

  collapseAllActivities() {
    if (this.groupedHistory) {
      this.groupedHistory.forEach(group => {
        if (group.activities) {
          group.activities.forEach((act: any) => act.expandedText = false);
        }
      });
    }
  }

  formatActivityText(text: string): string {
    if (!text) return '';
    const limit = 100;
    let content = text;
    if (content.length > limit) {
      content = content.substring(0, limit) + ' ...';
    }
    return this.highlightStatusBold(content);
  }

  // --- Grouping and UI helpers ---
  groupHistoryByDate(data: any[]): any[] {
    if (!data || !Array.isArray(data)) return [];
    // Group by date (YYYY-MM-DD)
    const groups: { [date: string]: { displayDate: string, activities: any[], expanded: boolean } } = {};
    data.forEach(item => {
      const dateObj = new Date(item.date);
      const dateKey = dateObj.toISOString().split('T')[0];
      const displayDate = dateObj.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
      if (!groups[dateKey]) {
        groups[dateKey] = { displayDate, activities: [], expanded: true };
      }
      groups[dateKey].activities.push({
        ...item,
        dateObj,
        type: this.deriveActivityType(item.text),
        expandedText: false
      });
    });
    // Sort groups by date desc, and activities by time desc
    return Object.values(groups)
      .sort((a, b) => b.activities[0].dateObj - a.activities[0].dateObj)
      .map(group => {
        group.activities.sort((a, b) => b.dateObj - a.dateObj);
        return group;
      });
  }

  deriveActivityType(text: string): string {
    if (!text) return 'default';
    const lowerText = text.toLowerCase();
    if (lowerText.includes('assigned to')) return 'assign';
    if (lowerText.includes('removed from')) return 'unassign';
    if (lowerText.includes('status was changed')) return 'status';
    if (lowerText.includes('created')) return 'create';
    if (lowerText.includes('comment')) return 'comment';
    if (lowerText.includes('updated') || lowerText.includes('edited')) return 'edit';
    return 'default';
  }

  getDotClass(type: string): string {
    switch (type) {
      case 'remove': // Fallback for old data
      case 'unassign': return 'dot-remove';
      case 'delete': return 'dot-remove';
      case 'status': return 'dot-status';
      case 'assign': return 'dot-assign';
      case 'create': return 'dot-create';
      case 'comment': return 'dot-comment';
      case 'edit': return 'dot-edit';
      default: return 'dot-default';
    }
  }

  highlightStatusBold(text: string): string {
    if (!text) return '';
    // Bold key terms and project names for visual emphasis
    const terms = [
      'In-Progress', 'Open', 'Waiting Cost Approval',
      'Project Management', 'Event Ops Test'
    ];
    const regex = new RegExp(`\\b(${terms.join('|')})\\b`, 'g');
    return text.replace(regex, '<span style="font-weight:800;color:#111">$1</span>');
  }

  formatTimelineTime(date: Date | string): string {
    // Always show as hh:mm AM/PM (12hr, pad hour/minute if needed)
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d.getTime())) return '';
    let h = d.getHours();
    let m = d.getMinutes();
    const ampm = h >= 12 ? 'PM' : 'AM';
    let hour12 = h % 12;
    if (hour12 === 0) hour12 = 12;
    const hh = hour12 < 10 ? '0' + hour12 : '' + hour12;
    const mm = m < 10 ? '0' + m : '' + m;
    return `${hh}:${mm} ${ampm}`;
  }
}
